import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import { UnidadeOrcamentariaService } from "../../services/UnidadeOrcamentariaService";
import { ExercicioService } from "../../services/ExercicioService";
export default {
    name: "GerenciarUnidadeOrcamentarias",
    components: {
        Breadcrumb,
        ActionButtons,
        StandardPagination
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Unidades Orçamentárias',
                disabled: true
            }
        ],
        headers: [
            { text: 'Exercício', align: 'center', value: 'exercicio', sortable: true },
            { text: 'Código Unidade', align: 'center', value: 'codigo_unidade', sortable: true },
            { text: 'Descrição Unidade', align: 'center', value: 'nome', sortable: true },
            { text: 'Status', align: 'center', value: 'ativo', sortable: true },
        ],
        filters: {
            codigoUnidadeOrcamentariaFilter: '',
            nomeUnidadeOrcamentariaFilter: '',
            exercicioFilter: null,
            statusFilter: null,
        },
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        itemsPerPage: 10,
        showFilters: true,
        loading: false,
        items: [],
        itemSelected: [],
        exerciciosOptions: [],
        page: 1,
        totalItems: 0
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        }
    },
    created() {
        this.listarUnidadesOrcamentariasPaginado();
        this.listarExerciciosSelect();
    },
    watch: {
        'filters.codigoUnidadeOrcamentariaFilter': function() {
            this.page = 1;
            this.listarUnidadesOrcamentariasPaginado();
        },
        'filters.nomeUnidadeOrcamentariaFilter': function() {
            this.page = 1;
            this.listarUnidadesOrcamentariasPaginado();
        },
        'filters.exercicioFilter': function() {
            this.page = 1;
            this.listarUnidadesOrcamentariasPaginado();
        },
        'filters.statusFilter': function() {
            this.page = 1;
            this.listarUnidadesOrcamentariasPaginado();
        }
    },
    methods: {
        async listarUnidadesOrcamentariasPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await UnidadeOrcamentariaService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os Unidades Orçamentárias.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os Unidades Orçamentárias:', error);
            } finally {
                this.loading = false;
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },
        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        truncateText(text, maxLength) {
            if (!text) return '-';
            return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
        },
        getRowClass(item) {
            return item ? 'custom-row' : '';
        },
        navigateToCreate() {
            this.$router.push('/unidades-orcamentarias/criar');
        },
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/unidades-orcamentarias/editar/${this.itemSelected[0].id}`);
            }
        },
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },
        handlePageChanged(newPage) {
            this.page = newPage;
            this.listarUnidadesOrcamentariasPaginado();
        },
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarUnidadesOrcamentariasPaginado();
        },
        async destroyUnidadesOrcamentarias() {
            try {
                const ids = this.itemSelected.map(unidadeOrcamentaria => unidadeOrcamentaria.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("unidadeOrcamentarias[]", id);
                });

                const response = await UnidadeOrcamentariaService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os Unidades Orçamentárias.');
                }

                this.listarUnidadesOrcamentariasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os Unidades Orçamentárias:', error);
            }
        },
        async activateUnidadesOrcamentarias() {
            try {
                const ids = this.itemSelected.map(unidadeOrcamentaria => unidadeOrcamentaria.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("unidadeOrcamentarias[]", id);
                });

                const response = await UnidadeOrcamentariaService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os Unidade Orçamentárias.');
                }

                this.listarUnidadesOrcamentariasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os Unidade Orçamentárias:', error);
            }
        },
        async deactivateUnidadesOrcamentarias() {
            try {
                const ids = this.itemSelected.map(unidadeOrcamentaria => unidadeOrcamentaria.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("unidadeOrcamentarias[]", id);
                });

                const response = await UnidadeOrcamentariaService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os Unidades Orçamentária.');
                }

                this.listarUnidadesOrcamentariasPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os Unidades Orçamentária:', error);
            }
        },
        prepareFormFilter() {
            const filter = new FormData();

            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);

            if (this.filters.codigoUnidadeOrcamentariaFilter) {
                filter.append("codigo", this.filters.codigoUnidadeOrcamentariaFilter);
            }

            if (this.filters.nomeUnidadeOrcamentariaFilter) {
                filter.append("nome", this.filters.nomeUnidadeOrcamentariaFilter);
            }

            if (this.filters.exercicioFilter) {
                filter.append("exercicio", this.filters.exercicioFilter);
            }

            if (this.filters.statusFilter !== null) {
                filter.append("ativo", this.filters.statusFilter);
            }

            return filter;
        },
    }
};
